import { render } from "./Cyclorama.vue?vue&type=template&id=577dcffb"
import script from "./Cyclorama.vue?vue&type=script&lang=js"
export * from "./Cyclorama.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__